// src/components/layout/SocialLinks.jsx
//
// TikTok + Instagram + YouTube follow buttons, shared by both footers (MarketingFooter and
// Footer) so the handles are defined once. The same URLs are listed in the
// Organization `sameAs` JSON-LD in index.html — keep them in sync.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaTiktok, FaInstagram, FaYoutube } from 'react-icons/fa';

const SOCIAL_LINKS = [
  { href: 'https://www.tiktok.com/@logami.app', labelKey: 'footer.followTiktok', Icon: FaTiktok },
  { href: 'https://www.instagram.com/logami.app/', labelKey: 'footer.followInstagram', Icon: FaInstagram },
  { href: 'https://www.youtube.com/@Logami_app', labelKey: 'footer.followYoutube', Icon: FaYoutube },
];

export default function SocialLinks({ className = '', buttonClassName = '' }) {
  const { t } = useTranslation();

  return (
    <ul className={`flex items-center gap-2 ${className}`} aria-label={t('footer.followUs')}>
      {SOCIAL_LINKS.map(({ href, labelKey, Icon }) => (
        <li key={href}>
          <a
            href={href}
            target="_blank"
            rel="me noopener noreferrer"
            aria-label={t(labelKey)}
            title={t(labelKey)}
            className={`flex items-center justify-center w-12 h-12 rounded-full border transition-colors duration-200 active:scale-95 touch-manipulation focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 ${buttonClassName}`}
          >
            <Icon className="w-[18px] h-[18px]" aria-hidden="true" />
          </a>
        </li>
      ))}
    </ul>
  );
}
